import script from "./QuestionView.vue?vue&type=script&setup=%7Bname%3A%20'question'%7D&lang=ts"
export * from "./QuestionView.vue?vue&type=script&setup=%7Bname%3A%20'question'%7D&lang=ts"

import "./QuestionView.vue?vue&type=style&index=0&id=5ec187d4&scoped=true&lang=less"

import exportComponent from "/app/workspace/IBU-IFSP_PUBLIC/IBU-IFSP-OPENAPI/OPENAPI_WEB_PORTAL_BUILD_GKE_PIPELINE/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ec187d4"]])

export default __exports__